import { Component, Input } from '@angular/core';
import { Bind } from 'primeng/bind';
import { Card } from 'primeng/card';
import { ProgressSpinner } from 'primeng/progressspinner';
import { MeterGroup } from 'primeng/metergroup';
import { NgClass } from '@angular/common';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-contract-usages',
  templateUrl: './contract-usages.component.html',
  styleUrls: ['./contract-usages.component.scss'],
  imports: [Bind, Card, ProgressSpinner, MeterGroup, NgClass, TranslatePipe]
})
export class ContractUsagesComponent {
  @Input() isMeterDataLoading = false;
  @Input() isMeterDataEmpty = false;
  @Input() pagesExtractedTotal = 0;
  @Input() yearlyPageExtractionQuota = 0;
  @Input() meterGrouptotalPercent = 0;
  @Input() selectedContractRange = '';
  @Input() selectedPeriodLabel = '';
  @Input() hasExceededQuota = false;
  @Input() meterColor = 'var(--p-sd-primary-blue-500)';
}
